import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { StyledInputWithLabel } from 'lib/styles';
import Icon from 'components/Icon';

import {
	ErrorMessage,
	Button,
} from '../Login';

import PasswordIndicator from './PasswordIndicator';

const InputContainer = styled.div`
	position: relative;
`;

const Password = styled(StyledInputWithLabel)`
	margin: 10px 0 10px;
	padding-right: 40px;
`;

const ViewPassword = styled.div`
	position: absolute;
	top: 50%;
	right: 16px;
	transform: translateY(-1px);
	appearance: none;
	border: 0px;
	background-color: rgba(0,0,0,0);
	cursor: pointer;
	outline: none;

	&:hover {
		svg {
			fill: #6990D9;
			path {
				fill: #6990D9;
			}
		}
	}
`;

const PASSWORD_MIN_LENGTH = 6;

function scorePassword(pass) {
	let score = 0;

	// award every unique letter until 5 repetitions
	let letters = {};

	for (let i = 0; i < pass.length; i++) {
		letters[pass[i]] = (letters[pass[i]] || 0) + 1;
		score += 5.0 / letters[pass[i]];
	}

	// bonus points for mixing it up
	let variations = {
		digits: /\d/.test(pass),
		lower: /[a-z]/.test(pass),
		upper: /[A-Z]/.test(pass),
		nonWords: /\W/.test(pass)
	};

	let variationCount = 0;
	for (let check in variations) {
		variationCount += (variations[check] === true) ? 1 : 0;
	}
	score += (variationCount - 1) * 10;

	// If length is below limit, reduce points
	if (pass.length <= PASSWORD_MIN_LENGTH) {
		score = score * (pass.length / PASSWORD_MIN_LENGTH);
	}

	return score;
}

const EmailForm = props => {
	const { t } = props;

	return (
		<React.Fragment>
			<h1 style={{marginTop: 0}}>{t('login/New password')}</h1>

			{ !props.passwordChanged &&
			<React.Fragment>
			  <InputContainer>
			    <Password
			      label={t('login/password')}
			      type={props.viewPassword ? 'text' : 'password'}
			      defaultValue={props.password}
			      name="password"
			      onChange={event => props.handleInputChange(event)}
			      onBlur={event => props.handleInputBlur(event)}
			    />
			    <ViewPassword onClick={props.handleViewPassword}>
			      <Icon icon={props.viewPassword ? 'view-hide' : 'view-show'} />
			    </ViewPassword>
			  </InputContainer>
			  <PasswordIndicator t={t} strength={scorePassword(props.password)} />

			  { props.error &&
					<ErrorMessage>{t(props.error)}</ErrorMessage>
			  }

			  <Button type="submit" disabled={scorePassword(props.password) < 50}>{props.buttonText}</Button>
			</React.Fragment>
			}

			{ props.passwordChanged &&
			<p>{t('login/Password changed successfully!')}</p>
			}
		</React.Fragment>
	)
}

EmailForm.propTypes = {
	passwordChanged: PropTypes.bool,
	error: PropTypes.any,
	password: PropTypes.string,
	viewPassword: PropTypes.bool,
	buttonText: PropTypes.string,
	handleInputBlur: PropTypes.func,
	handleInputChange: PropTypes.func,
	handleViewPassword: PropTypes.func,
	t: PropTypes.func,
}

export default EmailForm
